import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { PageLayout } from '@backstage/frontend-plugin-api';
import type { PageLayoutProps } from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';

function CustomPageLayout(props: PageLayoutProps) {
  const { noHeader, children } = props;

  if (noHeader) {
    return <>{children}</>;
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        minHeight: 0,
      }}
    >
      {children}
    </div>
  );
}

const pageLayoutOverride = SwappableComponentBlueprint.make({
  name: 'page-layout',
  params: defineParams =>
    defineParams({
      component: Object.assign(CustomPageLayout, { ref: PageLayout.ref }),
      loader: () => CustomPageLayout,
    }),
});

export const pageLayoutModule = createFrontendModule({
  pluginId: 'app',
  extensions: [pageLayoutOverride],
});
